import { SignUp } from "@clerk/clerk-react";
import { resolveAppUrl } from "../lib/url";

export function SignUpPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 dark:bg-slate-950">
      <div className="w-full max-w-md">
        <SignUp
          routing="path"
          path={resolveAppUrl("/sign-up")}
          signInUrl={resolveAppUrl("/sign-in")}
          fallbackRedirectUrl={resolveAppUrl("/")}
          appearance={{
            elements: {
              rootBox: "w-full",
              card: "shadow-lg",
            },
          }}
        />
      </div>
    </div>
  );
}
